var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkThemeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1483_28726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2408 15.3716C17.4599 18.1496 14.3479 19.9923 10.8049 19.9999C5.31614 20.0118 0.809306 15.572 0.742938 10.0836C0.680517 4.91945 4.51727 0.638319 9.49399 0.00105317C9.60036 -0.0125796 9.66966 0.1091 9.60501 0.194647C8.40505 1.78297 7.69364 3.76051 7.69364 5.90469C7.69364 11.1415 11.9388 15.3866 17.1756 15.3866C17.8398 15.3866 18.4878 15.3185 19.1134 15.1884C19.2184 15.1666 19.2987 15.2813 19.2408 15.3716Z",
    fill: "#EFDA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1134 15.1881C19.2183 15.1663 19.2986 15.2808 19.2408 15.371C17.4562 18.1551 14.3349 19.9999 10.7827 19.9999C5.23719 19.9999 0.742188 15.5045 0.742188 9.95937C0.742188 7.74031 1.46188 5.68961 2.68105 4.02734C2.40426 4.93535 2.25289 5.89797 2.24684 6.89527C2.21297 12.4825 6.70031 16.9982 12.2876 16.998C14.3123 16.9979 16.1968 16.3987 17.7734 15.3675C18.2298 15.3394 18.6771 15.2789 19.1134 15.1881Z",
    fill: "#EDC148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1483_28726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkThemeColor);
export default __webpack_public_path__ + "static/media/dark-theme-color.796e3b1a785b8b713021fc958c408981.svg";
export { ForwardRef as ReactComponent };